<template>
  <div id="select">
    <h1>
      Pandemic Expenses Index
    </h1>
    <p>
      Select an industry from the dropdown to find out how employers are keeping
      their teams engaged throughout the lockdown
    </p>
    <Dropdown />
  </div>
</template>

<script>
import Dropdown from "./Dropdown";

export default {
  name: "Select",
  components: {
    Dropdown
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/scss/_colours.scss";

#select {
  margin: 0 30px;
  padding: 20px 0;
  text-align: center;
  border-bottom: 2px solid $teal;
  background-color: #000;
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 769px) {
    margin: 0 auto;
  }

  h1 {
    text-transform: uppercase;
    font-size: 25px;
    margin-bottom: 30px;
    margin-top: 0;
  }

  h1,
  p {
    color: white;
    max-width: 510px;
  }

  p {
    font-size: 14px;
    margin-bottom: 35px;
    margin-top: 0;
  }
}
</style>
